import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import PendingIcon from "@mui/icons-material/Pending";
import formatNumberWithCommas from "../../core/utils/formatNumberWithCommas";
import { CONVERSION_POINTS } from "../../core/constant";

const formatBonusValue = (points) => {
  const pointsStr = formatNumberWithCommas(points);
  const dollarStr = formatNumberWithCommas(points / CONVERSION_POINTS, {
    asCurrency: true,
  });
  return `${pointsStr} points (~$${dollarStr})`;
};

const PendingWelcomeBonusBanner = ({ items }) => {
  if (!items || !items.length) return null;
  return (
    <>
      {items.map((bonus) => (
        <Alert
          key={bonus.id}
          severity="info"
          icon={<PendingIcon fontSize="medium" />}
          sx={{ mb: 1.5, width: "100%", alignItems: "center" }}
        >
          Your <b>{formatBonusValue(bonus.cashbackPoints)}</b> welcome bonus
          from <b>{bonus.restaurantName}</b> for order{" "}
          <b>#{bonus.orderID}</b> will be added to your reward points soon.
        </Alert>
      ))}
    </>
  );
};

PendingWelcomeBonusBanner.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      cashbackPoints: PropTypes.number.isRequired,
      restaurantName: PropTypes.string.isRequired,
      orderID: PropTypes.string.isRequired,
    }),
  ),
};

export default PendingWelcomeBonusBanner;
